__turbopack_context__.v({
  "facebook-icon": "OnboardingSocialLinksPageForMobile-module-scss-module__I_CYla__facebook-icon",
  "instagram-icon": "OnboardingSocialLinksPageForMobile-module-scss-module__I_CYla__instagram-icon",
  "linkedin-icon": "OnboardingSocialLinksPageForMobile-module-scss-module__I_CYla__linkedin-icon",
  "social-inputs-group": "OnboardingSocialLinksPageForMobile-module-scss-module__I_CYla__social-inputs-group",
  "web-icon": "OnboardingSocialLinksPageForMobile-module-scss-module__I_CYla__web-icon",
});
